import { all, call, takeEvery } from 'redux-saga/effects'
import { JWT_STORAGE_KEY } from 'portal-modules/common/constants/keys'

import { default as alertSagas } from 'portal-modules/alerts-panel/redux/sagas'
import { default as authSagas } from 'portal-modules/auth/redux/sagas'
import { default as classifiedsSagas } from 'portal-modules/classifieds/redux/sagas'
import { default as commonSagas } from 'portal-modules/common/redux/sagas'
import { default as companyLinksSagas } from 'portal-modules/company-links/redux/sagas'
import { default as contactsSagas } from 'portal-modules/contacts/redux/sagas'
import { default as documentsSagas } from 'portal-modules/documents/redux/sagas'
import { default as eventSagas } from 'portal-modules/events/redux/sagas'
import { default as feedSagas } from 'portal-modules/community-feed/redux/sagas'
import { default as feedbackSagas } from 'portal-modules/feedback/redux/sagas'
import { default as guestSagas } from 'portal-modules/guests/redux/sagas'
import { default as inspectionsSagas } from 'portal-modules/inspections/redux/sagas'
import { default as insuranceSagas } from 'portal-modules/insurance-tp/redux/sagas'
import { default as ledgerSagas } from 'portal-modules/ledger/redux/sagas'
import { default as maintenanceSagas } from 'portal-modules/maintenance/redux/sagas'
import { default as messageSagas } from 'portal-modules/messages/redux/sagas'
import { default as officeInformationSagas } from 'portal-modules/office-information/redux/sagas'
import { default as paymentsSagas } from 'App/modules/payments/redux/sagas'
import { default as referralsSagas } from 'portal-modules/referrals/redux/sagas'
import { default as renewalsSagas } from 'portal-modules/renewals/redux/sagas'
import { default as rentables } from 'portal-modules/rentable-items/redux/sagas'
import { default as reviewsSagas } from 'portal-modules/reviews/redux/sagas'
import { default as servicesSagas } from 'portal-modules/services/redux/sagas'
import { default as settingsSagas } from 'portal-modules/settings/redux/sagas'
import { default as utilitiesSagas } from 'portal-modules/utilities/redux/sagas'
import { default as vehiclesSagas } from 'portal-modules/vehicles/redux/sagas'
import { default as commercialSagas } from 'portal-modules/salesinformation/redux/sagas'
import { default as usersSagas } from 'portal-modules/users/redux/sagas'
import { setSessionCookies } from 'portal-utils/session-cookies'
import { default as amenitiesModuleSagas } from 'App/modules/amenities/redux/sagas'
import tenantImprovementsSagas from 'App/modules/tenant-improvements/redux/sagas'

// generic saga for syncing jwts to localStorage from any action
function* watchToken() {
  yield takeEvery('*', function* syncAuthCode(action) {
    // if we've got an action with an object payload with either
    // a token string or a user object with a token string
    // we want to sync it to localStorage
    if (
      action.payload &&
      ((action.payload.toString() === '[object Object]' &&
        action.payload.token) ||
        (action.payload.user && typeof action.payload.user.token === 'string'))
    ) {
      yield call(
        setSessionCookies,
        JWT_STORAGE_KEY,
        action.payload.token || action.payload.user.token,
      )
    }
  })
}

export default function* rootSaga() {
  yield all(
    [
      ...alertSagas,
      ...authSagas,
      ...classifiedsSagas,
      ...commonSagas,
      ...companyLinksSagas,
      ...contactsSagas,
      ...documentsSagas,
      ...eventSagas,
      ...feedSagas,
      ...feedbackSagas,
      ...guestSagas,
      ...inspectionsSagas,
      ...insuranceSagas,
      ...ledgerSagas,
      ...maintenanceSagas,
      ...messageSagas,
      ...officeInformationSagas,
      ...paymentsSagas,
      ...referralsSagas,
      ...renewalsSagas,
      ...rentables,
      ...reviewsSagas,
      ...servicesSagas,
      ...settingsSagas,
      ...utilitiesSagas,
      ...vehiclesSagas,
      ...commercialSagas,
      ...usersSagas,
      ...amenitiesModuleSagas,
      ...tenantImprovementsSagas,
      watchToken,
    ].map(func => func()),
  )
}
